// Copyright: IQGeo Limited 2010-2019

export default function(...mixinsOrFactories) {
    const mixins = mixinsOrFactories.map(mixinOrFactory =>
        typeof mixinOrFactory == 'function' ? mixinOrFactory.prototype : mixinOrFactory
    );
    const proto = Object.assign.apply(null, [{}].concat(mixins));
    const factory = (...args) => {
        const obj = Object.create(proto);
        if (obj.initialize) obj.initialize(...args);
        return obj;
    };
    factory.prototype = proto;
    return factory;
}
